/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetOrganicVolumeOptions, GetOrganicVolumeResponses } from '../types/GetOrganicVolume'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Reports the USD notional traded by users who are not bots, broken down by asset or by tenant. Fills on books quoted in a non-currency asset have no USD notional and are left out.
 * @summary Report organic trading volume
 * {@link /v1/organic-traffic/volume}
 */
export function getOrganicVolume<ThrowOnError extends boolean = true>(
  options: Options<GetOrganicVolumeOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetOrganicVolumeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/organic-traffic/volume',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetOrganicVolumeResponses, ThrowOnError>>,
  )
}
